import { type FC } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import { FormattedMessage } from 'dibs-react-intl';
import ChairIcon from 'dibs-icons/exports/legacy/ChairOutlined.ts';

import { type GetHelpZendeskSellerItemTile_viewer$key } from './__generated__/GetHelpZendeskSellerItemTile_viewer.graphql.ts';

import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment GetHelpZendeskSellerItemTile_viewer on Viewer {
        item(itemId: $itemId) @include(if: $hasItemId) {
            title
            firstPhotoWebPath(size: small)
            dealerReference
            dibsReference
            dealerStatusDisplay
        }
    }
`;

const GetHelpZendeskSellerItemTile: FC<{ viewer: GetHelpZendeskSellerItemTile_viewer$key }> = ({
    viewer: viewerRef,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);

    const { item } = viewer;
    const { title, firstPhotoWebPath, dealerReference, dibsReference, dealerStatusDisplay } =
        item || {};

    return (
        <div
            className={classnames(
                dibsCss.flex,
                dibsCss.flexRow,
                dibsCss.itemsCenter,
                dibsCss.gapXSmall
            )}
        >
            <div className={classnames(dibsCss.hXxlarge, dibsCss.wXxlarge, dibsCss.minWXxlarge)}>
                {firstPhotoWebPath ? (
                    <img
                        alt={title || ''}
                        src={firstPhotoWebPath}
                        className={classnames(dibsCss.hFull, dibsCss.wFull, dibsCss.objectContain)}
                    />
                ) : (
                    <ChairIcon className={classnames(dibsCss.hXxlarge, dibsCss.wXxlarge)} />
                )}
            </div>
            <div className={classnames(dibsCss.flex, dibsCss.flexCol, dibsCss.gapYXsmall)}>
                <div className={dibsCss.sassyFontHeaderMedium}>{title}</div>
                <div className={dibsCss.sassyFontBodySmall}>
                    {dealerReference ? (
                        <FormattedMessage
                            id="getHelp.GetHelpZendeskSellerItem.sellerRef"
                            defaultMessage="Seller Ref {sellerRef}"
                            values={{ sellerRef: dealerReference }}
                        />
                    ) : (
                        <FormattedMessage
                            id="getHelp.GetHelpZendeskSellerItem.itemRef"
                            defaultMessage="Item Ref {itemRef}"
                            values={{ itemRef: dibsReference }}
                        />
                    )}
                    {dealerStatusDisplay && (
                        <>
                            {' | '}
                            <span className={dibsCss.sassyFontBodySmallHeavy}>
                                {dealerStatusDisplay}
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export { GetHelpZendeskSellerItemTile };
